export default __webpack_public_path__ + "static/media/login.15c701dd.jpg";